import React, { useState } from 'react';
import { useTheme } from '@material-ui/core/styles';

import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { FormControl, TextField } from '@material-ui/core';
import { getIconColour } from '../../../../helpers/app';
import CrmSection from './CrmSection';
import ReviewQueueIcon from '../../../../assets/icons/ReviewQueueIcon';
import Radio from '../../../../styles/templates/DSRadio';
import { useRatingStyles } from '../../../ProjectDetails/Sections/styles';
import { DSButton } from '../../../../components/Button/Button';
import { PROJECT_STATUS } from '../../../../interfaces/project';

type ApprovalValues = 'approved' | 'not-approved' | '';

type PropsType = {
  onChangeStatus: (status: PROJECT_STATUS, reason?: string) => void;
};

const CrmApproval: React.FC<PropsType> = ({ onChangeStatus }) => {
  const classes = useRatingStyles();
  const [approvalValue, setApprovalValue] = useState<ApprovalValues>('');
  const [reason, setReason] = useState<string>('');

  const theme = useTheme();

  const onClick = () => {
    const status = approvalValue === 'approved' ? PROJECT_STATUS.LIVE : PROJECT_STATUS.REJECTED;
    onChangeStatus(status, reason);
  };

  return (
    <CrmSection
      icon={<ReviewQueueIcon stroke={getIconColour(undefined, theme)} />}
      title="Approval"
      description="Select the status of approval for the app"
    >
      <div style={{ display: 'flex' }}>
        <FormControl>
          <RadioGroup
            aria-label="approval-status"
            className={classes.ratingRadioGroup}
            value={approvalValue}
            onChange={(e) => setApprovalValue(e.target.value as ApprovalValues)}
          >
            <FormControlLabel value="approved" control={<Radio />} label="Approved" />
            <FormControlLabel value="not-approved" control={<Radio />} label="Not Approved" />
          </RadioGroup>
        </FormControl>
        <div className={classes.descriptionWrapper}>
          <Typography>
            Everything is present and correct for the app to go live, an automatic email will be
            sent to inform the developer of this decision.
          </Typography>

          <Typography>
            The app needs some more information to go live. Tell the developer what needs updating
            for the app to be approved in the box below; this will then be emailed to the developer.
          </Typography>
        </div>
      </div>
      {approvalValue === 'not-approved' && (
        <TextField
          id="not-approved"
          type="text"
          rows="4"
          variant="outlined"
          autoComplete="off"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          focused={false}
          fullWidth
          multiline
          inputProps={{ 'aria-label': 'Rejection reason' }}
        />
      )}
      <DSButton onClick={onClick} disabled={!approvalValue}>
        Send Email
      </DSButton>
    </CrmSection>
  );
};

export default CrmApproval;
